export interface CategoryPropType {
    label: string;
    link: string;
    icon: string;
    description: string;
}

export const categoryProps: CategoryPropType[] = [
    {
        label: 'CRUD',
        link: 'crud',
        icon: 'pi-database',
        description: 'Create, read, update or delete Anchors and/or Versions.',
    },
    {
        label: 'Pending Changes',
        link: 'pending-changes',
        icon: 'pi-clock',
        description: 'View and manage pending changes.',
    },
    {
        label: 'MSC',
        link: 'msc',
        icon: 'pi-sitemap',
        description: 'Message Sequence Charts.',
    },
    {
        label: 'Reports',
        link: 'reports',
        icon: 'pi-file-export',
        description: 'Generate and export reports.',
    },
];
